import GoogleIdentityProvider from "clientState/GoogleIdentityProvider";
import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import withAuthContext from "./withAuthContext";

export default withAuthContext(
  withErrorBoundary(GoogleIdentityProvider, {
    name: "GoogleIdentityProvider",
  }),
);
